import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, UserRoundIcon } from 'lucide-react';
import type { AppView } from '../../types/selfService';
interface ViewSwitchProps {
  view: AppView;
  onChange: (view: AppView) => void;
}
const OPTIONS: {
  id: AppView;
  label: string;
  short: string;
  icon: typeof UserRoundIcon;
}[] = [{
  id: 'admin',
  label: 'Admin view',
  short: 'Admin',
  icon: ShieldCheckIcon
}, {
  id: 'employee',
  label: 'My view',
  short: 'Me',
  icon: UserRoundIcon
}];
export function ViewSwitch({
  view,
  onChange
}: ViewSwitchProps) {
  return <div className="flex rounded-xl bg-canvas p-1 ring-1 ring-inset ring-slate-200" role="radiogroup" aria-label="Switch view" data-id="element-242" data-mp="3011etx1r075y">
      {OPTIONS.map(({
      id,
      label,
      short,
      icon: Icon
    }) => {
      const active = view === id;
      return <button key={id} type="button" role="radio" aria-checked={active} onClick={() => onChange(id)} className={`relative flex h-8 items-center gap-1.5 rounded-lg px-3 text-xs font-medium transition ${active ? 'text-white' : 'text-slate-600 hover:text-navy'}`} data-id="element-243" data-mp="15ns3s0tk0dll">
            {active && <motion.span layoutId="view-switch" className="absolute inset-0 rounded-lg bg-navy" transition={{
          type: 'spring',
          bounce: 0.15,
          duration: 0.35
        }} data-id="element-244" data-mp="4mj2zg87hfje" />}
            <Icon className="relative h-3.5 w-3.5" aria-hidden="true" data-id="element-245" data-mp="9eakz2daqcxx" />
            <span className="relative hidden sm:inline" data-id="element-246" data-mp="eb111pp3p8jc">{label}</span>
            <span className="relative sm:hidden" data-id="element-247" data-mp="ide6eczxr4fl">{short}</span>
          </button>;
    })}
    </div>;
}